import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input() type: 'button' | 'reset' | 'submit' = 'button';
  @Input() color: 'primary' | 'secondary' | 'secondary-active' | 'four' | 'light' = 'primary';
  @Input() text = '';
  @Input() href?: string;
  @Input() size: 'small' | 'xs' | 'sm' | 'md' |  'medium' | 'large-md' | 'large' = 'medium';
  @Input() title?: string;
  @Input() square = false;
  @Input() disabled = false;
}
